export class SaveContactRoleInfo {
    id: number;
    contactId: number;
    contactRoleTypeId: number;
    companyId: number;
    isActive: boolean;
    isOnboarding: boolean;
    startDate: Date;
    endDate: Date;
    divisionId: number;
    deactivateChecklist?: boolean;
    checkForChecklist?: boolean;
    constructor(id: number, contactId: number, contactRoleTypeId: number, companyContactId: number, isActive: boolean,
        isOnboarding: boolean, startDate: Date, endDate: Date, divisionId: number, deactivateChecklist?: boolean,
        checkForChecklist?: boolean) {
        this.id = id;
        this.contactId = contactId;
        this.contactRoleTypeId = contactRoleTypeId;
        this.companyId = companyContactId;
        this.isActive = isActive;
        this.isOnboarding = isOnboarding;
        this.startDate = startDate;
        this.endDate = endDate;
        this.divisionId = divisionId;
        this.deactivateChecklist = deactivateChecklist;
        this.checkForChecklist = checkForChecklist;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/contacts/contact-nav/contact-info-category-lists/models/save-contact-role-info.ts